import React from "react";
import {Brands} from "@core-ui/utility";
import {Icon} from "../components/Icon";
import {IconContainerProps} from "../types";

const CrossBrandSVG = (
  <svg fill="none" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M27.0452 13.1934l4.129 3.0933-4.3355 3.0933 2.1678 4.8-5.0581.4267-.4129 5.2267-4.6452-2.24-2.9935 4.2666-2.9936-4.2666-4.64514 2.24-.4129-5.2267L2.7871 24.18l2.16774-4.8-4.129034-3.0933 4.129034-3.0933L2.7871 8.39336l5.16129-.42667.4129-5.33333 4.54191 2.24L15.8968.606689l2.9935 4.266671 4.6452-2.24.5161 5.33333 5.1613.42667-2.1677 4.80004zm-4.542 9.8133l1.342-.1067 2.6838-.4266-1.1355-2.56-.6193-1.28 1.1355-.8534 2.2709-1.6-2.2709-1.6-1.1355-.8533.6193-1.28 1.1355-2.56001-2.7871-.21333L22.4 9.56669l-.1032-1.38667-.2065-2.88-2.4774 1.17334-1.2387.53333-.8258-1.17333-1.6516-2.34667-1.5484 2.34667-.929 1.28-1.2388-.64-2.47737-1.17334-.20646 2.88-.10322 1.38667-1.34194.10667-2.78709.21333L6.4 12.66l.61935 1.28-1.13548.8534-2.27097 1.6 2.27097 1.6 1.13548.8533-.61935 1.28-1.13548 2.56 2.78709.2133 1.44516.1067L9.6 24.3934l.20645 2.88L12.2839 26.1l1.3419-.64.8258 1.1734L16 28.98l1.5484-2.3466.8258-1.1734 1.2387.64 2.5806 1.1734.2065-2.88.1032-1.3867z"
      fill="#000"
      fillRule="evenodd"
    />
    <path
      d="M17.0323 11.38c-.1033-.2133-.3097-.32-.5162-.32-.4129 0-.8258.2133-.929.64-.1032.4267 0 .8533.3097 1.1733l2.6839 2.4534h-7.6388c-.5161 0-.929.4266-.929.96 0 .5333.3097.96.8258 1.0666h7.742L15.7936 19.7c-.3097.2133-.4129.7467-.3097 1.0667.2064.4266.5161.64.929.64h.1032c.3097 0 .5162-.2134.6194-.32l4.5419-4.0534c.2065-.2133.3097-.5333.3097-.7466 0-.32-.1032-.5334-.3097-.7467l-4.6451-4.16z"
      fill="#000"
    />
  </svg>
);

const brandIconSVGs = {
  [Brands.Athleta]: CrossBrandSVG,
  [Brands.BananaRepublic]: CrossBrandSVG,
  [Brands.BananaRepublicFactoryStore]: CrossBrandSVG,
  [Brands.Gap]: CrossBrandSVG,
  [Brands.GapFactoryStore]: CrossBrandSVG,
  [Brands.OldNavy]: CrossBrandSVG,
  crossBrand: CrossBrandSVG,
};

export const ValueDrawerArrowBadgeOutlineIcon = (
  props: IconContainerProps
): JSX.Element => <Icon {...props} brandIconSVGs={brandIconSVGs} />;
